import React, { Component } from 'react';
import { t } from '../../../app/i18n';
import Select from 'antd/lib/select';
import Input from 'antd/lib/input';
import { connect } from 'react-redux';
import { encashmentStatusT, encashmentStatus } from '../../../common/enums'
import { Button } from 'antd';
import { 
  updateLoansEncashmentStatusActions, 
  selectLoansEcashmentStatusChangeResult,
  clearLoansEncashmentStatusActions
 } from '../../../features/loans/ducks';
import { bindActionCreators } from 'redux';
import Modal from 'antd/lib/modal';

const { Option } = Select;
const { TextArea } = Input;

const mapStateToProps = state => ({
  encashmentStatusChangeResult: selectLoansEcashmentStatusChangeResult(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      updateLoansEncashmentStatus: updateLoansEncashmentStatusActions.request,
      clearLoansEncashmentStatus: clearLoansEncashmentStatusActions
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class EncashmentStatus extends Component {

  state = {
    encashmentStatus: '',
    loans: []
  };

  onEncashmentStatusChange = e => {
    this.setState({ encashmentStatus: e });
  }

  onLoansChange = e => {
    var loans = e.target.value.match(/[0-9]+/g);
    this.setState({ loans: loans });
  }

  onSubmit = () => {
    const { actions } = this.props;
    actions.updateLoansEncashmentStatus({ 
      loans: this.state.loans,
      encashmentStatus: this.state.encashmentStatus 
    });
  };

  handleCancel = () => {
    const { actions } = this.props;
    actions.clearLoansEncashmentStatus();
  }

  render() {
    const { encashmentStatusChangeResult } = this.props;
    return (
      <div>
        { encashmentStatusChangeResult && (encashmentStatusChangeResult.loansDone != 0 || encashmentStatusChangeResult.loansIssue.length > 0) && 
          <Modal
              title={t('Zmena stavov')}
              onCancel={this.handleCancel}
              footer={null}
              visible={true}
            >
              <div>
                  <h3>Zmena stavov zbehla úspešne na {encashmentStatusChangeResult.loansDone} pôžičkách.</h3>
                  {encashmentStatusChangeResult.loansIssue.length > 0 && 
                    <h3>Pôžičky s týmito číslami sa nenašli: {encashmentStatusChangeResult.loansIssue.toString()}.</h3>
                  }
              </div>
          </Modal>
        }
        <div>
          <h2>Zmena stavov:   </h2>
          <Select onChange={this.onEncashmentStatusChange} size="default" placeholder={t('Vybrať stav')}>
            {Object.entries(encashmentStatus).filter(([key, value]) => value.visible).map( ([key,value]) => (
              <Option key={encashmentStatusT[value.code]} value={value.code}>
                {encashmentStatusT[value.code]}
              </Option>
            ))}
          </Select>
          <TextArea
            size="default"
            placeholder={t('Variabilné symboly pôžičiek')}
            autosize={{ minRows: 4, maxRows: 10 }}
            onChange={this.onLoansChange}
          />
          <Button onClick={this.onSubmit}>
          {t('Potvrdiť')}
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loan-management/components/EncashmentStatus.js